<!--
<header class="header">
  <img src="../assets/images/img_logofinsinfo_2.png" alt="Finsinfo Logo" class="logo">
  <div class="nav-links">
    <a href="#quienes-somos" class="nav-link" (click)="scrollToSection($event, 'quienes-somos')">Quiénes somos</a>
    <a href="#contactanos" class="nav-link" (click)="scrollToSection($event, 'contactanos')">Contáctanos</a>
  </div>
  <img src="../assets/images/img_icons8login96_1.png" alt="Login" class="login-icon" (click)="onLogin($event)">
</header>
-->
<app-modal-alertas></app-modal-alertas>

<section class="hero-section" id="inicio">
  <div class="row align-items-center hero-content">
    <div class="col-md-6 text-center text-md-left mb-4 mb-md-0">
      <img src="../assets/images/img_logo_finsinfo_3.png" alt="FINSINFO Logo" class="hero-logo">
    </div>
    <div class="col-md-6 hero-text">
      <h1 class="hero-title">Decisiones <span class="highlight">Financieras <br>Inteligentes</span> en Segundos</h1>
      <p class="hero-description">
        Evalúa el riesgo de tus clientes y proveedores con precisión y rapidez, gracias a nuestro algoritmo avanzado e inteligencia artificial.
        <img src="../../assets/images/pointer.gif" alt="Cursor" class="cursor-icon">
      </p>
    </div>
  </div>
  <div class="row mt-5"><!-- Agrega mt-5 aquí -->
    <div class="col-12 text-center">
      <a class="cta-button">
        <span class="cta-text">Evalúa tu empresa - Conoce cómo te analizan y ven tus acreedores.</span>
      </a>
    </div>
  </div>
</section>

<section class="how-it-works" id="como-funciona">
  <h2 class="section-title">¿Como funciona?</h2>
  <p class="section-description">
    Tomar decisiones financieras nunca fue tan sencillo. Con nuestra plataforma, obtienes información confiable y comprensible, para que puedas evaluar riesgos con seguridad y agilidad.
  </p>
 <div class="features-container">
  <div class="feature-card">
    <img src="../assets/images/img_arrow_1.svg" alt="" class="arrow-bg" aria-hidden="true">
    <img src="../../assets/images/identify.gif" alt="Identificación Rápida" class="feature-icon">
    <h3 class="feature-title">Identificación Rápida</h3>
    <p class="feature-description">
      Proporciona los datos básicos de la empresa y su sector. Nuestro sistema se encarga del resto, agilizando el proceso de evaluación.
    </p>
  </div>
  <div class="feature-card">
    <img src="../assets/images/img_arrow_1.svg" alt="" class="arrow-bg" aria-hidden="true">
    <img src="../assets/images/analisis.gif" alt="Análisis Automatizado" class="feature-icon">
    <h3 class="feature-title">Análisis Automatizado</h3>
    <p class="feature-description">
      Carga los estados financieros o la carpeta tributaria. Nuestra IA procesa y analiza la información en minutos.
    </p>
  </div>
  <div class="feature-card">
    <img src="../assets/images/reporte.gif" alt="Reporte Detallado" class="feature-icon">
    <h3 class="feature-title">Reporte Detallado</h3>
    <p class="feature-description">
      Obtén un informe completo con el score de riesgo, capacidad económica e indicadores clave para una toma de decisiones informada.
    </p>
  </div>
</div>
  <a  class="action-button">
    <span class="action-text">Conoce como te ven y evalúan <br><span class="action-highlight">tus acreedores</span></span>
  </a>
</section>

<section class="tools-section" id="herramientas">
  <h2 class="tools-title">
    Evalúa a tus clientes y proveedores con <span class="tools-highlight">herramientas similares</span> a las que utilizan las principales <span class="financial-highlight">instituciones financieras.</span>
  </h2>
  <div class="image-container">
  <img src="../assets/images/img_men_1.png" alt="Profesional usando FINSINFO" class="main-image">
  <!--
  <img src="../assets/images/puntmsg.png" alt="Evaluaciones" class="hover-img hover-img-left">
  <img src="../assets/images/comentmsg.png" alt="Comentario" class="hover-img hover-img-right">
  -->
</div>
  <a  class="tools-cta" >
    <span class="tools-cta-text">Evalúa tu empresa - Conoce cómo te analizan y ven tus acreedores.</span>
  </a>
</section>

<section class="benefits-section" id="beneficios">
  <div class="benefits-container">
    <div class="benefit">
      <img src="../assets/images/img_copia_1.svg" alt="Precisión Avanzada" class="benefit-icon">
      <h3 class="benefit-title">Precisión Avanzada</h3>
      <p class="benefit-description">Nuestro algoritmo propietario y IA garantizan evaluaciones exactas y confiables.</p>
    </div>
    <div class="benefit">
      <img src="../assets/images/img_megusta_1.png" alt="Interfaz Intuitiva" class="benefit-icon">
      <h3 class="benefit-title">Interfaz Intuitiva</h3>
      <p class="benefit-description">Diseñada para facilitar el uso, sin necesidad de conocimientos técnicos.</p>
    </div>
    <div class="benefit">
      <img src="../assets/images/img_candado_1.svg" alt="Resultados Inmediatos" class="benefit-icon">
      <h3 class="benefit-title">Resultados Inmediatos</h3>
      <p class="benefit-description">Genera reportes completos en cuestión de minutos.</p>
    </div>
    <div class="benefit">
      <img src="../assets/images/img_person_1.svg" alt="Gestión Eficiente" class="benefit-icon">
      <h3 class="benefit-title">Gestión Eficiente</h3>
      <p class="benefit-description">Control total sobre usuarios y reportes desde una sola plataforma.</p>
    </div>
    <div class="benefit">
      <img src="../assets/images/img_lista_1.svg" alt="Estrategia Proactiva" class="benefit-icon">
      <h3 class="benefit-title">Estrategia Proactiva</h3>
      <p class="benefit-description">Segmenta tu cartera y establece políticas de riesgo efectivas.</p>
    </div>
  </div>
</section>

<section class="about-section" id="quienes-somos">
  <div class="about-content">
    <img src="../assets/images/img_logo_finsinfo_3.png" alt="FINSINFO Logo" class="about-logo">
    <h2 class="about-title" >Quiénes somos</h2>
    <div class="about-card">
      <h3 class="about-card-title">Somos FINSINFO</h3>
      <p class="about-card-text">
        Somos una plataforma que transforma datos financieros en decisiones inteligentes. Ayudamos a emprendedores, pymes y profesionales a entender su información financiera con claridad, automatización y enfoque estratégico. Combinamos tecnología y experiencia para convertir reportes complejos en insights simples, accionables y en tiempo real.
        Nuestro objetivo es que cada empresa
        <span class="about-highlight">-sin importar su tamaño-</span> pueda tomar
        decisiones con confianza y visión.
      </p>
      <a  class="about-cta" >
        <span class="about-cta-text">Evalúa, analiza y crece con nosotros.</span>
      </a>
    </div>

  </div>
</section>

<section class="cta-section" id="contactanos">
  <h2 class="cta-title">¡¿Qué estás esperando?!</h2>
  <a class="contact-button"data-bs-toggle="modal"
    data-bs-target="#contactModal">
    <span class="contact-text">Contáctanos</span>
  </a>
</section>

<!-- Modal -->
<div class="modal fade modalContactanos" id="contactModal" tabindex="-1" aria-labelledby="contactModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <div class="modal-body d-flex p-0" style="height: 100%;">
        <div class="col-som d-flex flex-column justify-content-center text-center" style="flex: 0 0 38%; max-width: 38%;">
          <h2 style="color:rgba(42, 64, 139, 1) ;">Somos tu éxito financiero</h2>
          <p class="textcontactanos">
            Completa el formulario a continuación y nos pondremos en contacto contigo en breve.
            ¡Contáctanos hoy y descubre cómo podemos ayudarte a alcanzar tus metas financieras!
          </p>
          <div class="text-center mt-3">
            <img src="/assets/Logo Finsinfo.svg" alt="Logo" width="200" height="200" class="d-inline-block align-text-top" />
          </div>
        </div>
        <div class="col-Contacto d-flex justify-content-center align-items-center shadow" style="flex: 0 0 62%; max-width: 62%;">
          <form [formGroup]="contactoForm" class="w-100">
            <!-- ...inputs y botón... -->
            <div class="mb-3">
              <label for="name" class="form-label">Nombre</label>
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder=" Nombre*"
                required
                formControlName="nombre"
                oninvalid="this.setCustomValidity('Por favor, ingresa tu nombre')"
                oninput="this.setCustomValidity('')"
              />
            </div>
            <div class="mb-3">
              <label for="phone" class="form-label">Teléfono</label>
              <input
                type="tel"
                class="form-control"
                id="phone"
                placeholder=" Teléfono*"
                required
                formControlName="phone"
                oninvalid="this.setCustomValidity('Por favor, ingresa tu teléfono')"
                oninput="this.setCustomValidity('')"
              />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Correo</label>
              <input
                type="email"
                class="form-control"
                id="email"
                placeholder=" Correo*"
                required
                formControlName="email"
                oninvalid="this.setCustomValidity('Por favor, ingresa un correo válido')"
                oninput="this.setCustomValidity('')"
              />
            </div>
            <div class="mb-3">
              <label for="empresa" class="form-label">Nombre de la empresa (opcional)</label>
              <input
                type="text"
                class="form-control"
                id="empresa"
                placeholder=" Empresa"
                formControlName="empresa"
              />
            </div>
            <div class="d-flex justify-content-center">
              <button type="submit" class="btn btn-enviar" (click)="onSubmit()">Enviar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
